import { useState, useEffect } from 'react';
import { fetchAPI, UrlParams } from '../services/strapi';

function mapResponse(result: any, urlPrefix = "") {
  // const dateList = `${result.attributes.date}`.split('-');
  return {
    id: result.id,
    body: result.attributes.body,
    user: result.attributes.person_name,
    institution: result.attributes.institution,
    date: result.attributes.date,
    type: result.attributes.type,
    path: result.attributes.path
  };
}

export type Search = {
  paths: string[];
}

type apiResponse = {
  data: any[],
  meta: {
		pagination: {
			page: number,
			pageSize: number,
			pageCount: number,
			total: number
		}
	}
}

enum TYPE {
  legislativo="legislativo",
  jurisprudencia="jurisprudencia",
  doutrinal="doutrinal",
  comentario="comentario"
}

export type Comment = {
  id: string;
  body: string;
  user: string;
  institution: string;
  date: string;
  type: TYPE | string;
  path: string;
}

export type Response = {
  legislative?: Comment,
  jurisprudence?: Comment,
  doctrinal?: Comment,
  comments: Comment[],
  results: Comment[],
  pagination: {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
	}
}

function mountFilter(array: any[], field: string | undefined | null, fieldTitle: string, operator: string = "$containsi") {
  if(field) {
    let filter: any = {};
    filter[fieldTitle] = {};
    filter[fieldTitle][operator] = field;

    array.push(filter);
  }
}

function mapFilter(search: Search) {
  let filters: any = {};

  let or: any[] = [];
  if(search?.paths?.length) {
    search.paths.map((path) => {
      //$eq or $startsWith 
      mountFilter(or, path, 'path', '$eq');
      mountFilter(or, path+'#', 'path', '$eq');
      mountFilter(or, path.slice(0, -1), 'path', '$eq');
      return;
    })
    filters.$or = or;
  }

  let and: any[] = []
  // mountFilter(and, search.finalDate && search.finalDate + finalHour, 'final_date', '$lte');

  filters.$and = and;

  return filters
}

export function useComments(search: Search | null = null): Response {
  const initialData: Response = {
    comments: [],
    results: [], 
    pagination: {
      page: -1,
      pageCount: -1,
      pageSize: -1,
      total: -1
    }
  }
  const [data, setData] = useState<Response>(initialData);
  
  async function fetchData() {
    let query: UrlParams = {
      populate: "*",
      pagination: {
        page: 1,
        pageSize: 100
      },
      sort: ['date:desc'],
    };
    if(search) {
      query.filters = mapFilter(search);
    }

    setData(await makeRequest(query));
  }

  useEffect(() => {
    //if(data?.results?.length) return;
    fetchData();
  }, [data.pagination.page]); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
};


export async function getComments(search: Search | null = null,  page: number = 1): Promise<Response> {
  let query: UrlParams = {
    populate: "*",
    pagination: {
      page: page,
      pageSize: 100
    },
    sort: ['date:desc'],
  };
  if(search) {
    query.filters = mapFilter(search);
  }
  return await makeRequest(query);
}


async function makeRequest(query: any): Promise<Response> {
  const response: apiResponse = await fetchAPI("/comments", query);
  const results = response.data.map((item: any) => mapResponse(item));
  const doctrinal = results.find((value) => value.type === TYPE.doutrinal)
  const jurisprudence = results.find((value) => value.type === TYPE.jurisprudencia)
  const legislative = results.find((value) => value.type === TYPE.legislativo)
    return {
      results,
      comments: results.filter((value) => value.type === TYPE.comentario),
      doctrinal,
      jurisprudence,
      legislative,
      pagination: response.meta.pagination
    };
}